// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logo.svg";
import logo from "./assets/logo2.svg";
// Profile Image
import profile from "./assets/profile.jpg";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import redux from "./assets/techstack/redux.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import figma from "./assets/techstack/figma.png";
import java from "./assets/techstack/java.png";
import php from "./assets/techstack/php.png";
import mysql from "./assets/techstack/mysql.png";
import c from "./assets/techstack/c.png";
import laravel from "./assets/techstack/laravel.png";
import intellij from "./assets/techstack/intellij.png";
// Porject Images
import projectImage1 from "./assets/projects/project1.jpg";
import projectImage2 from "./assets/projects/project2.jpg";
import projectImage3 from "./assets/projects/project3.jpg";
import projectImage4 from "./assets/projects/project4.jpg";
import projectImage5 from "./assets/projects/project5.jpg";
import projectImage6 from "./assets/projects/project6.jpg";

// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "Pratham Karia",
  tagline: "I build things for web",
  img: profile,
  about: `I am a motivated and aspiring engineering student with a strong interest in development. I possess a solid foundation in Development and Debugging and enjoy applying innovation and curiosity, whether in application development or collaboration. My approach to work is to gain a complete understanding of what is required and to find the most effective way to bring it to life.`,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/pratham-karia-6a1802247/",
  github: "https://github.com/prathzzzz",
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: "Full Stack Developer",
    Company: `UniqueStrands LLC`,
    Location: "Remote",
    Type: "Internship",
    Duration: "Dec 2023 - Jan 2024",
    techStack: "HTML | CSS | JavaScript | React | PHP | MySQL | Laravel",
  },

];

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "Bachelors in Computer Science",
    Company: "Vivekanand Education Society's Institute of Technology",
    Location: "Chembur",
    Duration: "2022 - 2025",
    techStack: "CGPA: 8.2/10"
  },
  {
    Position: "Diploma in Computer Engineering",
    Company: "Vivekanand Education Society's Polytechnic",
    Location: "Chembur", 
    Duration: "2019 - 2022",
    techStack: "Percentage: 88%"
  }
];

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  react: react,
  redux: redux,
  sass: sass,
  tailwind: tailwind,
  bootstrap: bootstrap,
  vscode: vscode,
  postman: postman,
  npm: npm,
  git: git,
  github: github,
  figma: figma,
  java: java,
  php: php,
  mysql: mysql,
  c: c,
  laravel: laravel,
  intellij: intellij,

};

// Enter your Project Details here
// ... existing code ...

export const projectDetails = [
  {
    title: "Udemy Certificate Generator",
    image: projectImage6,
    description: `A React-based tool for generating professional Udemy-style certificates with customizable fields and downloadable output.`,
    techstack: "React | JavaScript | HTML | CSS",
    githubLink: "https://github.com/prathzzzz/udemy-certificate-generator",
    liveLink: "https://udemy-certificate-generator.netlify.app/",
  },
  {
    title: "Ecommerce-Rest",
    image: projectImage1,
    description: `A REST API for e-commerce platform with routes for managing buyers, sellers, products, and transactions. Includes authentication middleware and optimized database queries.`,
    techstack: "PHP | Laravel | MySQL | HTML | CSS | JavaScript",
    githubLink: "https://gitlab.com/prathzzzz/ecommerce-rest/",
  },
  {
    title: "Chat System",
    image: projectImage2,
    description: `A secure chat system supporting private and broadcast messaging using multi-threaded socket programming. Built with OOP principles for better maintainability.`,
    techstack: "Java | Sockets",
    githubLink: "https://github.com/prathzzzz/Chat-System",
  },
  {
    title: "SecureNote",
    image: projectImage3,
    description: `A Java-based notepad application with Caesar cipher encryption, featuring essential text-editing capabilities and file handling functionalities.`,
    techstack: "Java | AWT | I/O",
    githubLink: "https://github.com/prathzzzz/Notepad-Clone",
  },
  {
    title: "Blog CMS",
    image: projectImage4,
    description: `An admin platform for managing blog content with MVC architecture. Features include post, category, and tag management with optimized database performance.`,
    techstack: "PHP | Laravel | MySQL | HTML | CSS | JavaScript",
    githubLink: "https://github.com/prathzzzz/Blog-CMS-FilamentPHP",
  },
  {
    title: "Questionify",
    image: projectImage5,
    description: `A Q&A platform with voting system and favorite marking. Features email notifications and secure access control using Laravel's middleware and gates.`,
    techstack: "PHP | Laravel | MySQL | HTML | CSS | JavaScript",
    githubLink: "https://github.com/prathzzzz/stack-overflow-clone",
  },
];

// ... existing code ...

// Enter your Contact Details here
export const contactDetails = {
  email: "kariapratham@gmail.com",
};
